var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrgCompleteChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    rx: 41,
    fill: "#068F06"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9113 29.5184C57.38 29.9873 57.6433 30.623 57.6433 31.2859C57.6433 31.9489 57.38 32.5846 56.9113 33.0534L38.173 51.7918C37.9254 52.0395 37.6314 52.2359 37.3078 52.37C36.9842 52.504 36.6374 52.573 36.2872 52.573C35.9369 52.573 35.5901 52.504 35.2666 52.37C34.943 52.2359 34.649 52.0395 34.4013 51.7918L25.0913 42.4834C24.8526 42.2528 24.6621 41.977 24.5311 41.672C24.4001 41.3669 24.3311 41.0389 24.3282 40.7069C24.3253 40.375 24.3886 40.0458 24.5143 39.7386C24.64 39.4313 24.8256 39.1522 25.0604 38.9175C25.2951 38.6827 25.5742 38.4971 25.8815 38.3714C26.1887 38.2457 26.5179 38.1824 26.8498 38.1853C27.1818 38.1882 27.5098 38.2572 27.8149 38.3882C28.1199 38.5192 28.3957 38.7097 28.6263 38.9484L36.2863 46.6084L53.3747 29.5184C53.6068 29.2861 53.8825 29.1018 54.1859 28.9761C54.4894 28.8504 54.8146 28.7856 55.143 28.7856C55.4715 28.7856 55.7967 28.8504 56.1001 28.9761C56.4035 29.1018 56.6792 29.2861 56.9113 29.5184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgCompleteChecked);
export default __webpack_public_path__ + "static/media/orgCompleteChecked.41ec3adccbea23d78bae04b03f53b1ec.svg";
export { ForwardRef as ReactComponent };